// en_pms_revenue.ts
// Tłumaczenia dla PMS.Revenue.tsx

export const enPmsRevenue = {

  title: "Revenue Management",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    forecast:          "Prognoza i spostrzeżenia",
    demandCalendar:    "Kalendarz popytu",
    activeRestrictions:"Aktywne ograniczenia",
    eventsImpact:      "Wpływ wydarzeń",
    conflictEngine:    "Silnik konfliktów",
    governance:        "Zarządzanie",
    derivedRules:      "Zasady pochodne",
    groupsBlocks:      "Grupy i blokady",
  },

  // ── Etykiety KPI / tabeli ─────────────────────────────────────────────────
  labels: {
    adrGap:           "Luka ADR",
    cancellationRate: "Wskaźnik anulowania",
    corporatePickup:  "Pickup korporacyjny",
    behindPace:       "Behind pace",
    onPace:           "On pace",
    base:             "Bazowa",
    active:           "Active",
    corporate:        "Korporacyjna",
    event:            "Event",
    forecast:         "Prognoza",
    critical:         "Critical",
  },

} as const;

export default enPmsRevenue;
